export default "__VITE_ASSET__D7$kvu9J__"